import { ButtonText, Col, Icon, Row } from "@visa/vds";
import React, { useState } from "react";
import { useEffect } from "react";
import NewCertificationPackageBtn from "pages/CertificationWorkflow/SharedComponents/NewCertificationPackageBtn";
import NewCertificationPackage from "pages/CertificationWorkflow/CertificationPackage/NewCertificationPackage";
import CertificationPackageWarningDialog from "./CertificationPackageWarningDialouge";
import { handleVstsButton } from "pages/CertificationWorkflow/SharedComponents/VstsAccessButton";

const CertificationPackagesAccordionActionItems = ({
    openPackageWarningDialog, setOpenSubscriptionWarningDialog,
    openNewCertificationPopup, setOpenNewCertificationPopup, totalCount, vstsAccess }) => {

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    return (
        <>
            <NewCertificationPackage open={openNewCertificationPopup} setOpen={setOpenNewCertificationPopup} />
            <CertificationPackageWarningDialog
                openPackageWarningDialog={openPackageWarningDialog}
                setOpenPackageWarningDialog={setOpenSubscriptionWarningDialog}
            />
            {!isMobile &&
                <Row className="vsts-vstt-header-row certification-package-row">
                    {vstsAccess &&
                        <Col textAlign="right" className="certification-package-action-col">
                            <ButtonText onClick={handleVstsButton} className="certification-package-btn" colorScheme="tertiary"><Icon name="maximize" resolution="low" />Go to Vsts</ButtonText>
                        </Col>
                    }
                    <Col textAlign="right" className="certification-package-action-col">
                        < NewCertificationPackageBtn setOpenSubscriptionWarningDialog={setOpenSubscriptionWarningDialog} setOpenNewCertificationPopup={setOpenNewCertificationPopup} totalCount={totalCount} />
                    </Col>
                </Row>
            }
            {isMobile &&
                <Row className="vsts-vstt-header-row certification-package-row">
                    {vstsAccess &&
                        <Col textAlign="right" className="certification-package-action-col">
                            <ButtonText onClick={handleVstsButton} className="certification-package-btn" colorScheme="tertiary"><Icon onClick={handleVstsButton} name="maximize" resolution="low" /></ButtonText>
                        </Col>
                    }
                    <Col textAlign="right" className="certification-package-action-col">
                        < NewCertificationPackageBtn btnText="" setOpenSubscriptionWarningDialog={setOpenSubscriptionWarningDialog} setOpenNewCertificationPopup={setOpenNewCertificationPopup} totalCount={totalCount} />
                    </Col>
                </Row>
            }
        </>
    )
}

export default CertificationPackagesAccordionActionItems;